import type { Component } from "vue";
import { createApp } from "vue";

import { initializeLanguage, language as languageRef, languageSignal } from "@core/composables/state/useLanguage";
import { authService } from "@core/services/authService";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import translateDirective, { TRANSLATE_LANGUAGE_KEY } from "@common/directives/translate";
import { resolveSupportedLanguage } from "@common/i18n";

import "./images/favicon.ico";
import "./images/favicon.svg";
import View from "./dashboard-view.vue";
import "./dashboard.css";
import router from "./router";

document.documentElement.lang = resolveSupportedLanguage(document.documentElement.lang);

authService.ensureAntiForgeryToken();

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Europe/Oslo");

const appInstance = createApp(View as Component);
appInstance.provide(TRANSLATE_LANGUAGE_KEY, languageSignal);
appInstance.directive("translate", translateDirective);
appInstance.use(router);

Promise.all([router.isReady(), initializeLanguage(languageRef.value)])
  .then(() => {
    appInstance.mount("#dashboard");
  })
  .catch(error => {
    console.error("[App] Router initialization error:", error);
    appInstance.mount("#dashboard");
  });
